import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "canvas-controls" }

import TextControlButton from '@/components/preview/TextControlButton.vue'
import DeleteIcon from '@/assets/DeleteIcon.svg'
import EditIcon from '@/assets/EditIcon.svg'
import FillToggleIcon from '@/assets/FillToggleIcon.svg'
import FitToggleIcon from '@/assets/FitToggleIcon.svg'
import FlipIcon from '@/assets/FlipIcon.svg'
import { useProjectStore } from '@/store/project-store'
import { useApplicationStore } from '@/store/application-store'
import useTextStates from '@/composables/UseTextStates'
import { computed } from 'vue'
import { TextImplementation } from '@/composables/UseTextCanvas'
import * as PIXI from 'pixi.js'
import { DisplayObjectPair } from '@/pixi/types'
import useDisplayObject from '@/composables/UseDisplayObject'
import useCanvasEventHandler from '@/composables/UseCanvasEventHandler'
import { BackgroundCanvasState } from '@/composables/UseBackgroundCanvas'


export default /*#__PURE__*/_defineComponent({
  __name: 'CanvasControls',
  props: {
    backgroundState: null,
    textDisplayObjectsMap: null,
    stickerDisplayObjectsMap: null,
    selectedTextImplementation: null
  },
  setup(__props: any) {

const props = __props as {
  backgroundState: BackgroundCanvasState,
  textDisplayObjectsMap: Map<number, DisplayObjectPair>,
  stickerDisplayObjectsMap: Map<number, DisplayObjectPair>,
  selectedTextImplementation?: TextImplementation
};

const projectStore = useProjectStore()
const applicationStore = useApplicationStore()

const { editText } = useTextStates()
const { getDisplayObjectSprite, updateDisplayObjState } = useDisplayObject()
const { onDeleteSticker, onDeleteText } = useCanvasEventHandler()



const showBackgroundControls = computed(() => !applicationStore.selectedSticker && !applicationStore.selectedText)
const showStickerControls = computed(() => applicationStore.selectedSticker)
const showTextControls = computed(() => applicationStore.selectedText && props.selectedTextImplementation?.isTextRasterised && (applicationStore.editTextState === 'none'))

const changeToggledState = (): void => {
  projectStore.toggleBackgroundScale()
}

const flipSticker = (): void => {
  if (applicationStore.selectedSticker) {
    const stickerSprite = getDisplayObjectSprite(applicationStore.selectedSticker, props.textDisplayObjectsMap, props.stickerDisplayObjectsMap)
    if (stickerSprite) {
      flipSprite(stickerSprite)
      updateDisplayObjState(applicationStore.selectedSticker, props.textDisplayObjectsMap, props.stickerDisplayObjectsMap)
    }
  }
}

const flipBackground = (): void => {
  if (props.backgroundState.sprite) {
    flipSprite(props.backgroundState.sprite)
  }
}

const flipSprite = (sprite: PIXI.Sprite): void => {
  // 12 is to Mirror Horizontally, 0 is no rotation
  sprite.texture.rotate = sprite.texture.rotate === 12 ? 0 : 12
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(showTextControls))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(TextControlButton, {
            text: "Delete",
            onClick: _unref(onDeleteText)
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DeleteIcon), { class: "canvas-controls__button-icon" })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(TextControlButton, {
            text: "Edit",
            onClick: _unref(editText)
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(EditIcon), { class: "canvas-controls__button-icon" })
            ]),
            _: 1
          }, 8, ["onClick"])
        ], 64))
      : (_unref(showStickerControls))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(TextControlButton, {
              text: "Delete",
              onClick: _unref(onDeleteSticker)
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DeleteIcon), { class: "canvas-controls__button-icon" })
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(TextControlButton, {
              text: "Flip",
              onClick: flipSticker
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(FlipIcon), { class: "canvas-controls__button-icon" })
              ]),
              _: 1
            })
          ], 64))
        : (_unref(showBackgroundControls))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(TextControlButton, {
                text: "Flip",
                onClick: flipBackground
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FlipIcon), { class: "canvas-controls__button-icon" })
                ]),
                _: 1
              }),
              (_unref(projectStore).background.backgroundScale === 'fit')
                ? (_openBlock(), _createBlock(TextControlButton, {
                    key: 0,
                    text: "Fill",
                    onClick: changeToggledState
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(FillToggleIcon), { class: "canvas-controls__button-icon" })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(TextControlButton, {
                    key: 1,
                    text: "Fit",
                    onClick: changeToggledState
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(FitToggleIcon), { class: "canvas-controls__button-icon" })
                    ]),
                    _: 1
                  }))
            ], 64))
          : _createCommentVNode("", true)
  ]))
}
}

})